function customValidate(str,regExpression){
    if(str.match(regExpression) != null){
        return true;
    }
    else{
        return false ;
    }
}
function validateEmail(email){
    let email_string = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(email.match(email_string)){
        return true;
    }else {
        return false;
    }

}
function validatePhone(phone){
    let letters =/[a-zA-Z\/\\\*\%\$\|\#\@\'\"\:\;\&\?\.\,\<\>]/g;
    if(phone.match(letters)){
        return false;
    }else{
        return true ;
    }
}
function validateTextInput(value) {
    const trimmed = value.trim();
    const regex = /^[a-zA-Zа-яА-ЯёЁіІїЇєЄґҐ\s\-'.]{2,}$/u;
    return regex.test(trimmed);
}
function validateSelect(value) {
    return value && value !== '---';
}
function validateTextWithDigits(value) {
    const trimmed = value.trim();
    const regex = /^[a-zA-Zа-яА-ЯёЁіІїЇєЄґҐ0-9\s\-'.]{4,}$/u;
    return regex.test(trimmed);
}
function debounce(func, delay) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), delay);
    };
}
document.addEventListener('DOMContentLoaded', function () {
    function initCount(){
        const countAll = document.querySelectorAll('.count');
        countAll.forEach(item => {
            const field = item.querySelector('.count-field');
            const input = field.querySelector('input');
            const title = item.querySelector('.count-value');
            const inc = item.querySelector('.count-inc');
            const dec = item.querySelector('.count-dec');
            let currentVal = parseInt(input.value);
            inc.addEventListener('click', function() {
                currentVal++;
                input.value = currentVal;
                title.innerHTML = currentVal;
            }, false);
            dec.addEventListener('click', function() {
                if (currentVal) {
                    currentVal--;
                }
                input.value = currentVal;
                title.innerHTML = currentVal;
            }, false);
        });
    }

    function toggleGift() {
        $('.cart-gift__heading').on('click', function() {
            const $parent = $(this).closest('.cart-gift');
            if (!$parent.hasClass('show')) {
                $parent.addClass('show');
                $parent.find('.cart-gift__content').slideDown(250);
            } else {
                $parent.removeClass('show');
                $parent.find('.cart-gift__content').slideUp(250);
            }
        });
    }

    function initCartSymbolCount() {
        const textarea = document.querySelector('[name="attributes[Gift Message]"]');
        const hint = document.querySelector('[name="attributes[Gift Message]"] + .cart-gift__box-hint');
        if(hint !== null && textarea !== null){
            const hintNumber = hint.dataset.textNumber;

            if (!textarea || !hint) return;
            textarea.setAttribute('maxlength', hintNumber);
            const maxLength = parseInt(textarea.getAttribute('maxlength'), 10);

            const updateHint = () => {
                const remaining = maxLength - textarea.value.length;
                hint.textContent = `${remaining} characters remaining`;
            };

            updateHint();

            if (!textarea.dataset.listenerAttached) {
                textarea.addEventListener('input', updateHint);
                textarea.dataset.listenerAttached = 'true';
            }
            function observeCartGiftBox() {
                let retries = 10;
                const interval = setInterval(() => {
                    initCartSymbolCount();
                    if (--retries <= 0) clearInterval(interval);
                }, 500);
            }
            window.addEventListener('load', () => {
                observeCartGiftBox();
            });
        }
    }

    initCartSymbolCount();
    async function renderCartModal() {
        try {
            const response = await fetch(window.shopUrl);
            if (!response.ok) throw new Error('Network response was not ok');

            const text = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, 'text/html');

            const newCartModal = doc.querySelector('.cart-modal');
            const oldCartModal = document.querySelector('.cart-modal');

            if (newCartModal && oldCartModal) {
                oldCartModal.innerHTML = newCartModal.innerHTML;
                if (newCartModal.id) {
                    oldCartModal.id = newCartModal.id;
                } else {
                    oldCartModal.removeAttribute('id');
                }
                oldCartModal.className = newCartModal.className + ' show';
                let headerCartButton = document.querySelector('.me-header-cart');
                if(headerCartButton != null){
                    let headerCartButtonText = newCartModal.dataset.cartText;
                    let headerCartId = newCartModal.dataset.cartId;
                    headerCartButton.href = headerCartId;
                    headerCartButton.textContent = headerCartButtonText;
                }
                initCount();
                initCartModal();
            }
        } catch (error) {
            console.error('Error updating cart modal:', error);
        }
    }

    async function addToCartById(variantId, quantity = 1, additionProduct) {
        if (!variantId || isNaN(variantId)) {
            console.error("❌ Invalid product variant ID");
            return;
        }
        try {
            const button = document.querySelector(`.product-info__buy [data-variant-id="${variantId}"]`);
            const maxStock = button ? parseInt(button.dataset.maxStock || '0', 10) : Infinity;
            if (button.dataset.trackInventory == 'true') {
                const cart = await fetch('/cart.js').then(res => res.json());
                const existingItem = cart.items.find(item => item.id == variantId);
                const currentQuantityInCart = existingItem ? existingItem.quantity : 0;
                if (currentQuantityInCart + quantity > maxStock) {
                    if( document.querySelector('.product-info__note.error-stock') != null){
                        document.querySelector('.product-info__note.error-stock').classList.remove('hidden')
                        document.querySelector('.product-info__note.error-stock').textContent = `There are already ${currentQuantityInCart} items in your cart. Maximum available: ${maxStock}.`;
                        setTimeout(function () {
                            document.querySelector('.product-info__note.error-stock').classList.add('hidden')
                        },3000)
                    }
                    // alert(`There are already ${currentQuantityInCart} items in your cart. Maximum available: ${maxStock}.`);
                    return;
                }
            }

            // Додаємо до кошика
            const response = await fetch(window.routes.cart_add_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: quantity
                })
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error("❌ Full error response:", errorData);

                if (errorData?.description) {
                    console.error(`❌ Shopify error: ${errorData.description}`);
                } else if (errorData?.message) {
                    console.error(`❌ Shopify error: ${errorData.message}`);
                } else {
                    console.error("❌ Unknown error when adding product to cart.");
                }
                return;
            }

            const cartItem = await response.json();
            console.log("✅ Product added to cart:", cartItem);

            const additionBlock = document.querySelector('.product-info__summary-small');
            if (additionProduct == 'true' && additionBlock !== null) {
                additionBlock.style.display = 'none';
            }

            await renderCartModal();

        } catch (error) {
            console.error("🚨 Error adding to cart:", error);
        }
    }

    async function updateCartQuantity(variantId, quantity, maxQuantity) {
        const containerLoading = document.querySelector('.container-loading');
        const dataCartForm = document.querySelector('[data-cart-form]');
        if (containerLoading != null) {
            containerLoading.classList.add('loading');
        }

        console.log(1)
        if(quantity != undefined && Number(quantity) > Number(maxQuantity)){
            document.querySelector(`[data-variant-id="${variantId}"]`).value = maxQuantity;
            document.querySelector(`[data-variant-id="${variantId}"]`).dispatchEvent(new Event('input', { bubbles: true }));
            document.querySelector(`[data-variant-id="${variantId}"]~.count-value`).textContent = maxQuantity;
            if(document.querySelector('.cart-modal__subtitle') != null){
                document.querySelector('.cart-modal__subtitle, .cart-error').textContent = window.translations.max_available + ' ' + maxQuantity;
                document.querySelector('.cart-modal__subtitle, .cart-error').style.color = 'red';
            }else if(document.querySelector('.cart-error') != null){
                document.querySelector('.cart-error').classList.remove('hidden')
            }

            setTimeout(function () {
                if(document.querySelector('.cart-modal__subtitle') != null){
                    document.querySelector('.cart-modal__subtitle').textContent = document.querySelector('.cart-modal__subtitle').dataset.text;
                    document.querySelector('.cart-modal__subtitle').style.color = '';
                }else if(document.querySelector('.cart-error') != null){
                    document.querySelector('.cart-error').classList.add('hidden')
                }
            }, 3000)

            if (containerLoading != null) {
                containerLoading.classList.remove('loading');
            }
            if (dataCartForm != null) {
                dataCartForm.classList.remove('loading');
            }
        }else{
            try {
                const response = await fetch(window.routes.cart_update_url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        updates: {
                            [variantId]: quantity
                        }
                    })
                });
                if (!response.ok) {
                    let errorMessage = 'Failed to update cart';

                    switch (response.status) {
                        case 422:
                            errorMessage = 'We have reached the maximum available quantity of product.';
                            break;
                        case 400:
                            errorMessage = 'Bad request: Please check your request data.';
                            break;
                        case 401:
                            errorMessage = 'Unauthorized: You need to log in first.';
                            break;
                        case 404:
                            errorMessage = 'Product not found: The requested variant doesn’t exist.';
                            break;
                        case 500:
                            errorMessage = 'Server error: Something went wrong on our end, please try again later.';
                            break;
                        default:
                            errorMessage = `Unexpected error: ${response.statusText}`;
                    }
                    document.querySelector(`[data-variant-id="${variantId}"]`).value = maxQuantity;
                    document.querySelector(`[data-variant-id="${variantId}"]~.count-value`).textContent = maxQuantity;
                    // alert(errorMessage);
                    throw new Error(errorMessage);
                }
                await renderCartModal();
            } catch (error) {
                console.error('Error updating cart quantity:', error);
            } finally {
                if (containerLoading != null) {
                    containerLoading.classList.remove('loading');
                }
                renderCartPage();
            }
        }

    }

    function initCartModal() {
        const cartModal = document.querySelector('.cart-modal');
        if(cartModal != null){
            const containerLoading = cartModal.querySelector('.container-loading');
            let itemsCart = cartModal.querySelectorAll('.cart-box');
            if(itemsCart.length > 0){
                itemsCart.forEach(function (item) {
                    let input = item.querySelector('input[name="quantity"]');
                    let maxQuantity = input.dataset.maxQuantity;
                    let variantId = input ? input.dataset.variantId : null;

                    if (input) {
                        input.addEventListener('input', debounce(function () {
                            updateCartQuantity(variantId, input.value, maxQuantity);
                        }, 300));
                    }

                    let countDec = item.querySelector('.count-dec');
                    let countInc = item.querySelector('.count-inc');

                    if (countDec && countInc) {
                        setTimeout(function () {
                            countDec.addEventListener('click', debounce(function () {
                                updateCartQuantity(variantId, input.value, input.dataset.maxQuantity);
                            }, 300));

                            countInc.addEventListener('click', debounce(function () {
                                updateCartQuantity(variantId, input.value, input.dataset.maxQuantity);
                            }, 300));

                            if(containerLoading != null){
                                containerLoading.classList.remove('loading');
                            }
                        },200)
                    }
                });
            }
        }
    }

    function initPdpOptionSwitcher() {
        const optionsBlock = document.querySelector('.product-info__options');
        const priceBlock = document.querySelector('.product-info__price');
        const buttonAddToCart = document.querySelector('.product-info__buy [data-variant-id]');
        const productJson = window.product_json;

        if(optionsBlock !== null && buttonAddToCart !== null && productJson){
            let optionInputs = optionsBlock.querySelectorAll('.product-info__val input');
            optionInputs.forEach(function (item) {
                item.addEventListener('input', function () {
                    const values = [];
                    optionInputs.forEach(input => {
                        if (input.checked) {
                            values.push(input.value);
                        }
                    });
                    const selectedVariantTitle = values.join(' / ');
                    const matchedVariant = productJson.variants.find(variant => variant.title === selectedVariantTitle);
                    const matchedVariantAvailable = matchedVariant.available;

                    if (matchedVariant) {
                        if(priceBlock !== null){
                            let symbol = priceBlock.dataset.currencySymbol;
                            priceBlock.textContent = symbol + Math.floor(matchedVariant.price / 100);
                        }
                        if(matchedVariantAvailable){
                            buttonAddToCart.textContent = window.translations.add_to_cart;
                            buttonAddToCart.style.pointerEvents = 'auto';
                        }else{
                            buttonAddToCart.textContent = window.translations.sold_out;
                            buttonAddToCart.style.pointerEvents = 'none';
                        }
                        buttonAddToCart.dataset.variantId = matchedVariant.id;
                        const url = new URL(window.location.href);
                        url.searchParams.set('variant', matchedVariant.id);
                        window.history.replaceState({}, '', url);
                    } else {
                        console.log("Error, variant don't found");
                    }
                })
            })
        }
    }

    function initPdpAddToCart() {
        const buttonAddToCart = document.querySelector('.product-info__buy [data-variant-id]');
        if(buttonAddToCart !== null){
            buttonAddToCart.addEventListener('click',function () {
                let variantId = buttonAddToCart.dataset.variantId;
                addToCartById(variantId);
            })
        }
    }

    async function renderCartPage(giftSubmit){
        console.log('renderCartPage')
        try {
            const response = await fetch(window.routes.cart_url);
            if (!response.ok) throw new Error('Network response was not ok');

            const text = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, 'text/html');

            const cartPageBlockFetch = doc.querySelector('[data-cart-form]');
            const cartPageBlock = document.querySelector('[data-cart-form]');

            const headerCartCountFetch = doc.querySelector('[data-header-cart-count]');
            const headerCartCount = document.querySelector('[data-header-cart-count]');

            if (cartPageBlockFetch && cartPageBlock !== null) {
                cartPageBlock.innerHTML = cartPageBlockFetch.innerHTML;
                initCount();
                toggleGift();
                initCartPage();
                initCartSymbolCount();
                if(giftSubmit){
                    cartPageBlock.querySelector('.cart-gift').classList.add('show');
                    cartPageBlock.querySelector('.cart-gift .cart-gift__content').style.display = 'block';
                    cartPageBlock.querySelector('.cart-gift__box-body .gift-text-success').classList.remove('hidden');
                    setTimeout(function () {
                        cartPageBlock.querySelector('.cart-gift__box-body .gift-text-success').classList.add('hidden');
                    }, 3000)
                }
                cartPageBlock.classList.remove('loading');
            }

            if(headerCartCountFetch != null && headerCartCount != null){
                headerCartCount.innerHTML = headerCartCountFetch.innerHTML;
            }
        } catch (error) {
            console.error('Error updating cart:', error);
            cartPageBlock.classList.remove('loading');
        }
    }
    
    function initCartPage() {
        const cartPageForm = document.querySelector('#cart-page-form');
        if(cartPageForm !== null){
            const saveButton = document.querySelector('.cart-gift__box-button button');
            if (saveButton != null) {
                saveButton.addEventListener('click', async () => {
                    const formData = new FormData(cartPageForm);
                    try {
                        const response = await fetch(cartPageForm.action, {
                            method: 'POST',
                            body: formData,
                            headers: {
                                'Accept': 'application/json',
                            },
                        });

                        if (response.ok) {
                            const data = await response.json();
                            renderCartPage(true);
                        } else {
                            console.error('Form submit failed:', response.status);
                        }
                    } catch (error) {
                        console.error('Error submitting form:', error);
                    }
                });
            }

            const countsItemQuantity = cartPageForm.querySelectorAll('.count-icon');
            const countsItemRemove = cartPageForm.querySelectorAll('.cart-box__action a');

            if(countsItemQuantity.length > 0){
                countsItemQuantity.forEach(function (item) {
                    item.addEventListener('click', function (e) {
                        e.preventDefault();
                        const cartPageBlock = document.querySelector('[data-cart-form]');
                        if(cartPageBlock != null){
                            cartPageBlock.classList.add('loading');
                        }
                        setTimeout(function () {
                            const id = item.closest('.count').querySelector('input').dataset.variantId;
                            const maxQ = item.closest('.count').querySelector('input').dataset.maxQuantity;
                            const q = item.closest('.count').querySelector('input').value;
                            console.log(id, q,maxQ);
                            updateCartQuantity(id, q, maxQ).then(r => {
                                    // renderCartPage();
                                })
                        },300)
                    })
                })
            }
            if(countsItemRemove.length > 0){
                countsItemRemove.forEach(function (item) {
                    item.addEventListener('click', function (e) {
                        e.preventDefault();
                        const cartPageBlock = document.querySelector('[data-cart-form]');
                        if(cartPageBlock != null){
                            cartPageBlock.classList.add('loading');
                        }
                        setTimeout(function () {
                            const id = item.closest('.cart-box').querySelector('input').dataset.variantId;
                            console.log(id, 0);
                            updateCartQuantity(id, 0).then(r => {
                                renderCartPage();
                            })
                        },300)
                    })
                })
            }
        }
    }

    function initCollectionFilter() {
        const form = document.getElementById('CollectionFiltersForm');
        const productGrid = document.getElementById('CollectionProductGrid');
        const filtersRow = document.querySelector('.filters__row');

        if (!form || !productGrid || !filtersRow) return;
        function showLoader(){
            const filters = document.querySelector('.filters');
            if(filters != null) filters.classList.toggle('loading')
        }
        const applyFilters = () => {
            const formData = new FormData(form);
            const searchParams = new URLSearchParams(formData).toString();

            showLoader();

            fetch(`${form.action}?${searchParams}`, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
                .then(res => res.text())
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');

                    const newGrid = doc.querySelector('#CollectionProductGrid');
                    const newResults = doc.querySelector('.filters__results');
                    const newFiltersForm = doc.querySelector('.collection__filters-form');

                    if (isMobileOrSmallScreen()) {
                        const buttonSubmit = document.querySelector('.filters__show-results button');
                        if(buttonSubmit != null){
                            buttonSubmit.addEventListener('click', () => {
                                if (newGrid) {
                                    productGrid.innerHTML = newGrid.innerHTML;
                                }

                                const resultsCount = document.querySelector('.filters__results');
                                if (newResults && resultsCount) {
                                    resultsCount.innerHTML = newResults.innerHTML;
                                }

                                const filtersForm = document.querySelector('.collection__filters-form');
                                if (newFiltersForm && filtersForm) {
                                    filtersForm.innerHTML = newFiltersForm.innerHTML;
                                }
                                initDropdown();
                                initFilterClearButtons();
                                history.pushState({}, '', `${form.action}?${searchParams}`);
                            })
                        }
                    } else {
                        if (newGrid) {
                            productGrid.innerHTML = newGrid.innerHTML;
                        }

                        const resultsCount = document.querySelector('.filters__results');
                        if (newResults && resultsCount) {
                            resultsCount.innerHTML = newResults.innerHTML;
                        }

                        const filtersForm = document.querySelector('.collection__filters-form');
                        if (newFiltersForm && filtersForm) {
                            filtersForm.innerHTML = newFiltersForm.innerHTML;
                        }
                        initDropdown();
                        initFilterClearButtons();
                        history.pushState({}, '', `${form.action}?${searchParams}`);
                    }
                })
                .catch(err => console.error('Error filtering:', err))
                .finally(() => {
                    showLoader();
                });
        };

        const debouncedApplyFilters = debounce(applyFilters, 300);

        form.addEventListener('change', () => {
            debouncedApplyFilters();
        });
        initFilterClearButtons();
        function initFilterClearButtons() {
            const clearButtons = document.querySelectorAll('.filters__clear .text');

            clearButtons.forEach(button => {
                button.addEventListener('click', (e) => {
                    const filterItem = e.target.closest('.filters__item');

                    if (!filterItem) return;

                    const checkboxes = filterItem.querySelectorAll('input[type="checkbox"]');

                    checkboxes.forEach(checkbox => {
                        checkbox.checked = false;
                    });

                    applyFilters();
                });
            });
        }
    }

    window.addToCartById = addToCartById;
    initCartModal();
    initPdpOptionSwitcher();
    initPdpAddToCart();
    // renderCartPage();
    initCartPage();
    initCollectionFilter();
});

function isMobileOrSmallScreen() {
    const isMobileDevice = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const isSmallScreen = window.innerWidth <= 766;
    return isMobileDevice || isSmallScreen;
}

function initDropdown() {
    const filters = document.querySelectorAll(".js-filter");

    document.addEventListener("click", (e) => {
        let clickedInside = false;

        filters.forEach((filter) => {
            const trigger = filter.querySelector(".js-filter-trigger");
            const dropdown = filter.querySelector(".js-filter-dropdown");

            if (filter.contains(e.target)) {
                const trigger = filter.querySelector(".js-filter-trigger");
                if (trigger.contains(e.target)) {
                    clickedInside = true;
                    const isOpen = !dropdown.hasAttribute("hidden");

                    filters.forEach(f => {
                        f.querySelector(".js-filter-dropdown").setAttribute("hidden", "");
                        f.classList.remove("filters__item--active");
                        f.querySelector(".js-filter-trigger").setAttribute("aria-expanded", "false");
                    });

                    if (!isOpen) {
                        dropdown.removeAttribute("hidden");
                        filter.classList.add("filters__item--active");
                        trigger.setAttribute("aria-expanded", "true");
                    }
                } else {
                    clickedInside = true; // Щоб не закривати при кліку по чекбоксу, але нічого не відкривати
                }
            }
        });

        if (!clickedInside) {
            filters.forEach(filter => {
                filter.querySelector(".js-filter-dropdown").setAttribute("hidden", "");
                filter.classList.remove("filters__item--active");
                filter.querySelector(".js-filter-trigger").setAttribute("aria-expanded", "false");
            });
        }
    });

    const labels = document.querySelectorAll(".filters__label");
    labels.forEach(label => {
        label.addEventListener("click", (e) => {
            const checkbox = label.querySelector("input[type='checkbox']");
            setTimeout(() => {
                label.classList.toggle("is-checked", checkbox.checked);
            }, 10);
        });
    });

    function isMobile() {
        return window.innerWidth <= 768 || /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    }

    if (isMobile()) {
        const openMobFilter = document.querySelector('.filters__row > .filters__trigger:not(.close)');
        const closeMobFilter = document.querySelector('.filters__row .filters__trigger.close > .filters__icon');
        if (closeMobFilter != null && openMobFilter != null) {
            const filtersItems = document.querySelector('.filters__items');
            openMobFilter.addEventListener('click', function () {
                if (filtersItems != null) {
                    filtersItems.classList.remove('hide');
                    document.body.classList.add('overflow-h');
                    document.querySelector('header').style.display = 'none';
                }
            })
            closeMobFilter.addEventListener('click', function () {
                if (filtersItems != null) {
                    filtersItems.classList.add('hide');
                    document.body.classList.remove('overflow-h');
                    document.querySelector('header').style.display = '';
                }
            })
        }
    }
}
function validateForm(form){
    let selectors = {
        "parent": ".input-wrap",
        "error_block": ".error",
        "error_class": "has-error"
    }

    let validation = true;
    let requiredFields = form.querySelectorAll('input[required]:not([type="checkbox"])');
    let requiredEmail = form.querySelectorAll('input[type="email"]');
    let phone = form.querySelectorAll('input[type="tel"]');
    let customValidation = form.querySelectorAll('input[data-custom-validation][type="text"]');
    let requiredTextarea = form.querySelectorAll('textarea[required]');
    let requiredSelect = form.querySelectorAll('select[required]');


    customValidation.forEach(function (field){
        let fieldValue = field.value.trim();
        let fieldRegExp = field.dataset.customValidation;
        if (fieldValue !== '' && fieldRegExp) {
            if (customValidate(field.value,fieldRegExp) != true) {
                validation = false;
                if(field.closest(selectors.parent)){
                    field.closest(selectors.parent).classList.add(selectors.error_class);
                    if(field.closest(selectors.parent).querySelector(selectors.error_block)){
                        field.closest(selectors.parent).querySelector(selectors.error_block).innerHTML = window.errors.custom_validation_error
                    }
                }
            }else {
                if(field.closest(selectors.parent)) {
                    field.closest(selectors.parent).classList.remove(selectors.error_class);
                }
            }
        }
    });
    requiredFields.forEach(function (field){
        let fieldValue = field.value.trim();
        if (fieldValue === '') {
            validation = false;
            if(field.closest(selectors.parent)){
                field.closest(selectors.parent).classList.add(selectors.error_class);
                if(field.closest(selectors.parent).querySelector(selectors.error_block)){
                    field.closest(selectors.parent).querySelector(selectors.error_block).innerHTML = window.errors.required_error
                }
            }
        }else{
            if(field.closest(selectors.parent)) {
                field.closest(selectors.parent).classList.remove(selectors.error_class);
            }
        }
    });

    requiredEmail.forEach(function (field){
        let fieldValue = field.value.trim();
        if (fieldValue === '') {
            validation = false;
            if(field.closest(selectors.parent)) {
                field.closest(selectors.parent).classList.add(selectors.error_class);
                if(field.closest(selectors.parent).querySelector(selectors.error_block)){
                    field.closest(selectors.parent).querySelector(selectors.error_block).innerHTML = window.errors.required_error
                }
            }
        }else {
            if (validateEmail(field.value) != true) {
                validation = false;
                if(field.closest(selectors.parent)){
                    field.closest(selectors.parent).classList.add(selectors.error_class);
                    if(field.closest(selectors.parent).querySelector(selectors.error_block)){
                        field.closest(selectors.parent).querySelector(selectors.error_block).innerHTML = window.errors.email_error
                    }
                }
            }else {
                if(field.closest(selectors.parent)) {
                    field.closest(selectors.parent).classList.remove(selectors.error_class);
                }
            }
        }
    });
    phone.forEach(function (field){
        let fieldValue = field.value.trim();
        if (fieldValue !== '') {
            if (validatePhone(field.value) != true) {
                validation = false;
                if(field.closest(selectors.parent)){
                    field.closest(selectors.parent).classList.add(selectors.error_class);
                    if(field.closest(selectors.parent).querySelector(selectors.error_block)){
                        field.closest(selectors.parent).querySelector(selectors.error_block).innerHTML = window.errors.phone_error
                    }
                }
            }else {
                if(field.closest(selectors.parent)) {
                    field.closest(selectors.parent).classList.remove(selectors.error_class);
                }
            }
        }else{
            if(field.closest(selectors.parent)) {
                field.closest(selectors.parent).classList.remove(selectors.error_class);
            }
        }
    });
    requiredTextarea.forEach(function (field){
        let fieldValue = field.value.trim();
        if (fieldValue === '') {
            validation = false;
            if(field.closest(selectors.parent)){
                field.closest(selectors.parent).classList.add(selectors.error_class);
                if(field.closest(selectors.parent).querySelector(selectors.error_block)){
                    field.closest(selectors.parent).querySelector(selectors.error_block).innerHTML = window.errors.required_error
                }
            }
        }else{
            if(field.closest(selectors.parent)) {
                field.closest(selectors.parent).classList.remove(selectors.error_class);
            }
        }
    });
    requiredSelect.forEach(function (field){
        let fieldValue = field.value.trim();
        if (fieldValue !== '') {
            validation = false;
            if(field.closest(selectors.parent)){
                field.closest(selectors.parent).classList.add(selectors.error_class);
                if(field.closest(selectors.parent).querySelector(selectors.error_block)){
                    field.closest(selectors.parent).querySelector(selectors.error_block).innerHTML = window.errors.required_error
                }
            }
        }
    });
    return validation;
}

function addFormValidation(){
    let forms = document.querySelectorAll('.js-validate-form form');
    if(forms){
        forms.forEach(form=>{
            if(form.querySelector('button[type="submit"]')){
                form.querySelector('button[type="submit"]').addEventListener('click', (e)=>{
                    e.preventDefault();
                    let validationResult = validateForm(form);
                    if(validationResult){
                        form.submit();
                    }
                })
            }
        })
    }
}
addFormValidation();

function initContactForm() {
    const contactForm = document.querySelector('#contact_form');
    const submitButton = contactForm?.querySelector('.me-form-submit');

    if (!contactForm || !submitButton) {
        return;
    }

    submitButton.addEventListener('click', async function () {

        const formData = new FormData(contactForm);
        const action = contactForm.getAttribute('action') || window.location.href;

        try {
            const response = await fetch(action, {
                method: 'POST',
                body: formData,
                headers: {
                    'Accept': 'text/html',
                },
            });

            const responseText = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(responseText, 'text/html');

            const successBlock = contactForm.querySelector('.me-form-success');
            const formRows = contactForm.querySelectorAll('.me-form-row');


            const errors = doc.querySelectorAll('.me-form-row__error li');

            if (errors.length > 0) {
                let errorList = '<ul>';
                errors.forEach(err => {
                    errorList += `<li>${err.textContent}</li>`;
                });
                errorList += '</ul>';

                successBlock.innerHTML = errorList;
                successBlock.classList.remove('hidden');
            } else {
                successBlock.classList.remove('hidden');

                formRows.forEach(row => row.classList.add('hidden'));
                submitButton.classList.add('hidden');
            }

        } catch (error) {
            console.error('Error submit:', error);
        }
    });
}
initContactForm();
